import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const CityColumn = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelConfiguration, externalFulfillmentConfiguration } =
    useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};

  const shipTo = labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo;

  const { city } = shipTo ?? {};

  return city;
};

CityColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const City = {
  getMessageDescriptor: () => messages.city,
  id: 'city',

  render: (data) => {
    return <CityColumn fulfillmentId={data.id} />;
  },
};
